import { set, get, isEqual } from 'lodash';
export class K5QueryUtils {
    static get DefaultQuery() {
        return { match_all: {} };
    }
    static isK5Query(query) {
        return Boolean(query && (query.query_string || query.match_all));
    }
    static isDefault(query) {
        return isEqual(query, K5QueryUtils.DefaultQuery);
    }
    static compose(value = '') {
        if (Boolean(value)) {
            return { query_string: { query: value, analyze_wildcard: true } };
        }
        return K5QueryUtils.DefaultQuery;
    }
    static decorate(query = {}, value) {
        set(query, 'query_string.query', value);
        set(query, 'query_string.analyze_wildcard', true);
    }
    static getQueryString(query) {
        return get(query, 'query_string.query') || ''; // empty string for match_all case
    }
    /**
     * Must preserve query reference, modify don't override.
     */
    static update(query, value) {
        if (K5QueryUtils.isK5Query(query)) {
            if (K5QueryUtils.isDefault(query))
                delete query.match_all;
            K5QueryUtils.decorate(query, value);
        }
        return query;
    }
}
//# sourceMappingURL=kibana5-query-utils.js.map